export enum EventName {
  Approved = 'approved',
  Attachment = 'attachment',
  AttachmentUploaded = 'attachmentuploaded',
  AttachmentOpened = 'attachmentopened',
  Commented = 'commented',
  Created = 'created',
  Downloaded = 'downloaded',
  Forwarded = 'forwarded',
  GdprScrambled = 'gdpr-scrambled',
  Hardbounced = 'hardbounced',
  Printed = 'printed',
  Recalled = 'recalled',
  Rejected = 'rejected',
  Reviewed = 'reviewed',
  Scheduled = 'scheduled',
  Sealed = 'sealed',
  Sent = 'sent',
  Signed = 'signed',
  SignedWithoutVerification = 'signedwithoutverification',
  Transferred = 'transferred',
  Updated = 'updated',
  Verified = 'verified',
  PartiallySigned = 'partiallySigned',
  Viewed = 'viewed',
  EmailOpened = 'emailopened',
  VideoPlayed = 'videoplayed',
  Reminder = 'reminder',
  SmsReminder = 'sms',
  VideoReminder = 'video',
  Clicked = 'clicked',
  ExpirationDateUpdated = 'expirationDateUpdated',
  NotOpened = 'not_opened',
  NotApproved = 'not_approved',
  NotSigned = 'not_signed',
  Expiring = 'expiring',
  Unknown = 'unknown',
}
